import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class JobOfferService {
  private jobOffers = [
    {
      companyName: 'arq-it',
      jobTitle: 'Desarrollador Frontend',
      applyLink: 'info@arq-it.cl',
      location: 'Chile',
      salary: '$1.000.000 CL',
      experience: '2 a\u00F1os de experiencia en desarrollo frontend', 
      requirements: [
        'Conocimientos de HTML, CSS y JavaScript',
        'Experiencia con frameworks como Angular o React',
        'Capacidad para trabajar en equipo',
        'Nivel intermedio de ingl\u00E9s', 
      ],
    },
  ];

  getJobOfferByTitle(title: string) {
    return this.jobOffers.find(offer => offer.jobTitle === title) || null;
  }
}
